module.exports = __webpack_public_path__ + "images/assets/aec0ec6f22d976f7c87063a4d8ca987e.svg";